import {changePassword, synchroniseAccounts, getDeleteUserEmail, getOnlyAdminOrganisations} from '@/libs/api/api'
import {message, loader, openTermAndPrivacy, errorHandler, logout} from '@/libs/helper'
import constants from '@/libs/constant/constants'
import {getSyncedTwitterAccount, getFacebookAccounts} from '@/libs/api/api'
import {isEmpty, cloneDeep, sortBy, uniqBy} from 'lodash'
import {mapGetters} from 'vuex'

export default{
    components: {
        'PreferenceMenu' : () => import('@/components/pages/PreferenceMenu/PreferenceMenu.vue')
    },
    created() {
        this.getUserSocialAccounts()
    },
    computed: {
        ...mapGetters({
            isRefreshAccounts: 'getRefreshAccounts'
        })
    },
    watch: {
        isRefreshAccounts (value) {
            if (value) this.refreshAccounts()
        }
    },
    data(){
        return{
            isEmpty,
            isAccount: false,
            isDialogVisible: false,
            isUpdateAccounts: false,
            accounts: [],
            activeSyncronisedButton: '',
            openTermAndPrivacy: openTermAndPrivacy,
            dynamicValidateForm: {
                password: '',
                confirmPassword: '',
                existingPassword: ''
            }
        }
    },
    methods:{
        /*
        * manageDialog() manages opening and closing of
        * change password dialog
        * */
        manageDialog(){
            if(this.isDialogVisible === true){
                this.dynamicValidateForm.password= ''
                this.dynamicValidateForm.confirmPassword= ''
                this.dynamicValidateForm.existingPassword= ''
            }
            this.isDialogVisible = !this.isDialogVisible
        },
        /*
        * call the API to change the user password
        * */
        submitForm (formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if(this.dynamicValidateForm.confirmPassword === this.dynamicValidateForm.existingPassword){
                        message(this, constants.messageType.ERROR, ('New password can not be same as existing password'))
                    }else if(this.dynamicValidateForm.confirmPassword === this.dynamicValidateForm.password){
                        loader(this, true);
                        let body={
                            newPassword: this.dynamicValidateForm.confirmPassword,
                            oldPassword: this.dynamicValidateForm.existingPassword
                        }
                        changePassword(body)
                            .then((response) => {
                                if(response.success){
                                    loader(this, false);
                                    message(this, constants.messageType.SUCCESS, (response.message))
                                    this.manageDialog()
                                }
                            })
                            .catch((error) => {
                                loader(this, false);
                                if(error.code === 'INVALID_LOGIN'){
                                    message(this, constants.messageType.ERROR, ('Existing password is not correct.'))
                                }else{
                                    message(this, constants.messageType.ERROR, (error.message))
                                }
                            })
                    }else{
                        message(this, constants.messageType.ERROR, ('Password and Confirm password not matched'))
                    }

                }
            })
        },
        closeAccountPopup () {
            this.isAccount = false
        },

        /**
         * to get the social accounts of user
         * fb/twitter
         */
        getUserSocialAccounts: async function (isTrue) {
            try {
                this.accounts = []
                let twitterAccounts = await getSyncedTwitterAccount()
                twitterAccounts = twitterAccounts.twitter_accounts || []
                twitterAccounts = this.wrapTwitter(twitterAccounts)
                let fbAccounts = await getFacebookAccounts()
                fbAccounts = this.wrapFacebook(fbAccounts)
                let accounts = this.accounts.concat(twitterAccounts, fbAccounts)
                this.accounts = this.getAllAcounts(accounts)
                this.$store.dispatch('setAccounts', this.accounts)
                if (this.$route.query && this.$route.query.action && this.$route.query.action === 'add' && !isTrue) {
                    this.isAccount = true
                }
                if (isTrue) this.isUpdateAccounts = true
            } catch (error) {
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            }
        },

        /**
         * to set the response of facebook
         */
        wrapTwitter (twitterAccounts) {
            if (isEmpty(twitterAccounts)) return []
            twitterAccounts.map(twitter => {
                twitter._id = twitter.id
                twitter.name = twitter.twitter_profile_name || ''
                return twitter
            })
            return sortBy(twitterAccounts, 'name')
        },

        /**
         * to set the response of facebook
         */
        wrapFacebook (fbAccounts) {
            if (isEmpty(fbAccounts)) return []
            fbAccounts.map(fb => {
                fb.name = fb.first_name + ' ' + fb.last_name
                return fb
            })
            return sortBy(fbAccounts, 'name')
        },

        /**
         * to get all the accounts into one
         * @param {*} accounts 
         */
        getAllAcounts (accounts) {
            if (isEmpty(accounts)) return []
            return uniqBy(sortBy(accounts, 'type'), '_id')
        },
        /**
         * to update the accounts list
         */
        updateAccounts (accounts) {
            this.accounts = cloneDeep(accounts)
            // to update the the store
            this.$store.dispatch('setAccounts', accounts)
        },
        /**
         * to fetch again the accounts added
         */
        refreshAccounts () {
            this.getUserSocialAccounts(true)
            this.$store.dispatch('setRefreshAccounts', false)
        },
        /**
         * change isUpdateAccounts value
         */
        changeUpdateAccounts (isTrue) {
            this.isUpdateAccounts = isTrue
        },
        /**
         * to synchronise social accounts
         */
        syncAccounts (account) {
            // to hide the button if called from the popup
            this.isAccount = false
            // null condition
            if (isEmpty(account)) return
            this.activeSyncronisedButton = account._id
            // body for api
            let body = {
                facebook_mongo_id: account._id
            }
            // api call
            synchroniseAccounts(body).then(() => {
                // to revert the button to normal
                this.activeSyncronisedButton = ''
                // message on success
                message(this, constants.messageType.SUCCESS, 'Account is Synced successfully')
            }).catch(error => {
                // to revert the button to normal
                this.activeSyncronisedButton = ''
                // message on error
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                loader(this, false)
            })
        },
        /**
         * to update name in accounts
         * @param {} account 
         */
        updateNameInAccounts (account) {
            let accounts = cloneDeep(this.accounts)
            this.accounts = accounts.map(acc => {
              if ((acc._id === account._id)) acc = account
              return acc
            })
            this.$store.dispatch('setAccounts', this.accounts)
        },

        /**
         * fetch user delete email
         */
        async fetchUserDeleteEmail () {
            try {
                loader(this, true)
                let response = await getOnlyAdminOrganisations({user: (this.$store.getters.getUserInformation.id || this.$store.getters.getUserInformation._id)})
                if (!response.only_admin) {
                    let useEmailResponse = await getDeleteUserEmail()
                    if (useEmailResponse.success) message(this, constants.messageType.SUCCESS, 'Email has been sent!')
                }
                else {
                    message(this, constants.messageType.ERROR, 'You are a single Owner of an Organisation. Please Delete it first!')
                }
                
            } catch (error) {
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            }
            finally {
                loader(this, false)
            }
        }
    }
}
